import React, { CSSProperties } from 'react';
import { Button, Dropdown, Menu, Popup } from 'semantic-ui-react';
import { imprimirFormaDePago } from '../../utilidades';
import { FiltroCompromiso, FiltroSede, FormasDePago } from '../tipos';

interface Props {
    cantidadDeApoderados: number;
    cargando: boolean;
    diaDePago: number | undefined;
    formaDePago: FormasDePago | 'todos';
    año: number | 'todos';
    compromiso: FiltroCompromiso;
    sede: FiltroSede;
    alElegirDiaDePago(dia: number | undefined): void;
    alElegirAño(año: number | 'todos'): void;
    alElegirFormaDePago(formaDePago: FormasDePago | 'todos'): void;
    alElegirCompromiso(tipo: FiltroCompromiso): void;
    alElegirSede(sede: FiltroSede): void;
    alPresionarRecargar(): void;
    alPresionarCorreos(): void;
}

const styleMenuItem: CSSProperties = { paddingLeft: '5px' };

const nombreCompromiso: Record<FiltroCompromiso, string> = {
    conCompromiso: 'Con compromiso vigente',
    sinCompromiso: 'Sin compromiso vigente',
    todos: 'Con o sin compromiso',
};

const nombreSede: Record<FiltroSede, string> = {
    'alameda': 'Solo Alameda',
    'san-fernando': 'Solo San Fernando',
    'uchile': 'Solo U. de Chile',
    'todos': 'Cualquier sede',
};

const MenuTabla: React.FunctionComponent<Props> = props => {
    const {
        cantidadDeApoderados,
        cargando,
        diaDePago,
        formaDePago,
        año,
        compromiso,
        sede,
        alElegirDiaDePago,
        alElegirFormaDePago,
        alElegirAño,
        alElegirCompromiso,
        alElegirSede,
        alPresionarRecargar,
        alPresionarCorreos,
    } = props;

    const diaDePagoDesactivado =
        formaDePago === 'contado' || formaDePago === 'tarjeta' || formaDePago === 'todos';

    return (
        <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Button
                            basic
                            icon='refresh'
                            loading={cargando}
                            onClick={alPresionarRecargar}
                        />
                    }
                    content='Recargar'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={<Button basic icon='mail outline' onClick={alPresionarCorreos} />}
                    content='Mostrar correos'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Dropdown
                            fitted='vertically'
                            text={
                                formaDePago !== 'todos'
                                    ? imprimirFormaDePago(formaDePago)
                                    : 'Todas las formas'
                            }
                            item
                        >
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => alElegirFormaDePago('pagare')}
                                    content={imprimirFormaDePago('pagare')}
                                />
                                <Dropdown.Item
                                    onClick={() => alElegirFormaDePago('cheque')}
                                    content={imprimirFormaDePago('cheque')}
                                />
                                <Dropdown.Item
                                    onClick={() => alElegirFormaDePago('contado')}
                                    content={imprimirFormaDePago('contado')}
                                />
                                <Dropdown.Item
                                    onClick={() => alElegirFormaDePago('tarjeta')}
                                    content={imprimirFormaDePago('tarjeta')}
                                />
                                <Dropdown.Item
                                    onClick={() => alElegirFormaDePago('todos')}
                                    content='Todas'
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    content='Forma de pago'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Dropdown
                            fitted='vertically'
                            text={año !== 'todos' ? año.toString() : 'Cualquier año'}
                            item
                        >
                            <Dropdown.Menu>
                                {[2019, 2020, 2021, 2022, 2023, 2024, 2025, undefined].map(
                                    añoElegido => (
                                        <Dropdown.Item
                                            key={añoElegido || 'todos'}
                                            onClick={() => alElegirAño(añoElegido || 'todos')}
                                        >
                                            {añoElegido !== undefined
                                                ? añoElegido.toString()
                                                : 'Cualquiera'}
                                        </Dropdown.Item>
                                    ),
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    content='Forma de pago'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <div>
                            <Dropdown
                                fitted='vertically'
                                text={
                                    diaDePago !== undefined
                                        ? diaDePago.toString() + ' de cada mes'
                                        : 'Cualquier día'
                                }
                                item
                                disabled={diaDePagoDesactivado}
                            >
                                <Dropdown.Menu>
                                    {[5, 10, 15, 20, 25, 30, undefined].map(dia => (
                                        <Dropdown.Item
                                            key={dia || 'todos'}
                                            onClick={() => alElegirDiaDePago(dia)}
                                        >
                                            {dia !== undefined ? dia.toString() : 'Cualquiera'}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                    content={
                        diaDePagoDesactivado
                            ? 'Solo aplica si forma de pago es pagaré o cheque'
                            : 'Día de pago'
                    }
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Dropdown fitted='vertically' text={nombreCompromiso[compromiso]} item>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    content={nombreCompromiso.sinCompromiso}
                                    onClick={() => alElegirCompromiso('sinCompromiso')}
                                />
                                <Dropdown.Item
                                    content={nombreCompromiso.conCompromiso}
                                    onClick={() => alElegirCompromiso('conCompromiso')}
                                />
                                <Dropdown.Item
                                    content={nombreCompromiso.todos}
                                    onClick={() => alElegirCompromiso('todos')}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    content='Compromiso'
                />
            </Menu.Item>

            <Menu.Item fitted style={styleMenuItem}>
                <Popup
                    inverted
                    trigger={
                        <Dropdown fitted='vertically' text={nombreSede[sede]} item>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    content={nombreSede.todos}
                                    onClick={() => alElegirSede('todos')}
                                />
                                <Dropdown.Item
                                    content={nombreSede.alameda}
                                    onClick={() => alElegirSede('alameda')}
                                />
                                <Dropdown.Item
                                    content={nombreSede['san-fernando']}
                                    onClick={() => alElegirSede('san-fernando')}
                                />
                                <Dropdown.Item
                                    content={nombreSede.uchile}
                                    onClick={() => alElegirSede('uchile')}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    content='Sede'
                />
            </Menu.Item>

            <Menu.Item position='right'>{cantidadDeApoderados} apoderados</Menu.Item>
        </Menu>
    );
};

export default MenuTabla;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Deudores/componentes/MenuTabla.tsx